export default {
  // 账单状态
  billStatus: [
    {label:'待确认',value:'0'},
    {label:'已确认',value:'1'},
    { label:'已结算',value:'2'},
  ],
  // 商户分类
  supplyKind:[
    {label:'内部商户',value:'1'},
    { label:'外部商户',value:'2'},
  ],
};
